// extracted by mini-css-extract-plugin
module.exports = {"row":"history_row__1HEt6uGl6NhmznqjXplOjr","container":"history_container__2h61DVExTEsF_QUGHn1MJp"};